module.exports = __webpack_public_path__ + "static/img/roland_message.9a32889.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/company/roland_message.svg
// module id = r3eE
// module chunks = 0